export default __webpack_public_path__ + "static/media/toothbrush.821030fe.jpg";